// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team .content {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    padding-bottom: 30px;
    padding-bottom: 130px;
}

.team .member {
    border: 1px solid #E6E6E6;
    width: 900px;
}

.team .member .header {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background-color: #F5F5F5;
    border-bottom: 1px solid #E6E6E6;
}

/* .team .member .add-member {
    
} */

.team .table th {
    font-weight: 400;
    color: #A0A0A0;
    /* font-size: 12px; */
}

.team .table td {
    color: #6A6A6A;
    /* font-size: 12px; */
    text-transform: capitalize;
}

.team .modal .modal-header {
    display: block;
}

.team .modal .modal-header h4 {
    font-size: 18px;
    color: #000000;
    margin-bottom: 5px;
}

.team .modal .modal-header p {
    color: #A0A0A0;
    margin-bottom: 0;
}

.team .modal .form-control {
    background-color: transparent;
    box-shadow: none;
}

.team .modal .action {
    background-color: #F5F5F5;
    padding: 10px;
}

.team .modal .cancel-btn {
    background-color: transparent;
    border: 1px solid #C1BCBC;
    border-radius: 4px;
    padding: 10px;
}

.team .modal .add-btn {
    background-color: #4D68C9;
    color: #ffffff;
    border-radius: 4px;
    border: none;
}

.team .modal small {
    color: #E86880;
}

.team .modal .error {
    border: 1px solid #E86880;
}

.team .modal .modal-body {
    margin: 40px 10px;
    padding: 10px;
    background-color: #FFEFE0;
}

.team .modal .modal-body p {
    margin-bottom: 0;
    color: #640000;
}

.team .modal .delete-btn {
    background-color: #DE0000;
    border: none;
    color: #ffffff;
    padding: 10px;
    border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/onboarding/Team.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;GAEG;;AAEH;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".team .content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 30px;\n    padding-bottom: 30px;\n    padding-bottom: 130px;\n}\n\n.team .member {\n    border: 1px solid #E6E6E6;\n    width: 900px;\n}\n\n.team .member .header {\n    display: flex;\n    justify-content: space-between;\n    padding: 20px;\n    background-color: #F5F5F5;\n    border-bottom: 1px solid #E6E6E6;\n}\n\n/* .team .member .add-member {\n    \n} */\n\n.team .table th {\n    font-weight: 400;\n    color: #A0A0A0;\n    /* font-size: 12px; */\n}\n\n.team .table td {\n    color: #6A6A6A;\n    /* font-size: 12px; */\n    text-transform: capitalize;\n}\n\n.team .modal .modal-header {\n    display: block;\n}\n\n.team .modal .modal-header h4 {\n    font-size: 18px;\n    color: #000000;\n    margin-bottom: 5px;\n}\n\n.team .modal .modal-header p {\n    color: #A0A0A0;\n    margin-bottom: 0;\n}\n\n.team .modal .form-control {\n    background-color: transparent;\n    box-shadow: none;\n}\n\n.team .modal .action {\n    background-color: #F5F5F5;\n    padding: 10px;\n}\n\n.team .modal .cancel-btn {\n    background-color: transparent;\n    border: 1px solid #C1BCBC;\n    border-radius: 4px;\n    padding: 10px;\n}\n\n.team .modal .add-btn {\n    background-color: #4D68C9;\n    color: #ffffff;\n    border-radius: 4px;\n    border: none;\n}\n\n.team .modal small {\n    color: #E86880;\n}\n\n.team .modal .error {\n    border: 1px solid #E86880;\n}\n\n.team .modal .modal-body {\n    margin: 40px 10px;\n    padding: 10px;\n    background-color: #FFEFE0;\n}\n\n.team .modal .modal-body p {\n    margin-bottom: 0;\n    color: #640000;\n}\n\n.team .modal .delete-btn {\n    background-color: #DE0000;\n    border: none;\n    color: #ffffff;\n    padding: 10px;\n    border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
